import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../../services/auth/auth.service';
import { ROUTE_PATHS } from '../../utils/route-paths.const';

/**
 * Unauth Guard
 * Prevents authenticated users from accessing auth pages
 * Redirects to home if already authenticated
 */
export const unauthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (!authService.isAuthenticated()) {
    return true;
  }

  router.navigate([ROUTE_PATHS.ROOT]);
  return false;
};
